import router from './router'
// import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
// import { Message } from 'element-ui'
import { getNewToken } from '@/utils/auth' // 验权

NProgress.configure({ showSpinner: false }) // NProgress Configuration
const whiteList = ['/login'] // 不重定向白名单,不登录可见白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getNewToken() && getNewToken() !== '') {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
    }
  } else {
    // Message.error('身份验证已失效, 请重登！')
    localStorage.clear()
    sessionStorage.clear()
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 跳到重新登陆之前清除之前的localStorage
      localStorage.clear()
      sessionStorage.clear()
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js